import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// @mui
import { Box, Grid } from '@mui/material';

// components
import Page from 'components/Page';
// sections
import { LoginForm } from 'sections/auth/login';
// utils
import { ACTIONS } from 'utils/constants';
import axios from 'utils/axios';

import API from 'restApi';

// ----------------------------------------------------------------------

export default function Login() {
  const { t } = useTranslation();
  const [version, setVersion] = useState("");

  useEffect(() => {
    async function getVersion() {
      const { data } = await axios.post(API.path, {
        action: ACTIONS.IVRSVERSION
      });

      setVersion(data.version);
    }
    getVersion();
    // eslint-disable-next-line
  }, []);

  return (
    <Page title={t('login.title')}>
      <Box className="wrapper_intro">
        <Box className="wrapper_intro_ins">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={7} />
            <Grid item xs={12} sm={12} md={4}>
              <Box className="wrapper_intro_form">
                <Box className="wrapper_logo" />
                <LoginForm />
              </Box>
              <Box className="wrapper_intro_footer">
                <Box className="wrapper_intro_footer_logo" />
                <Box className="wrapper_intro_footer_info">{t('login.footer', { version })}</Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

      </Box>

    </Page>
  );
}
